export const environment = {
  production: true,
  apiUrl: 'https://dsp-fileprocessing-func.azurewebsites.net/api',
  appName: 'KS DSP SPA',
  version: '1.0.0',
  azureConfig: {
    clientId: '297477b6-8858-4fd3-b3af-a94ca8417383',
    authority: 'https://login.microsoftonline.com/f6d94abc-5472-43af-ab66-95726e5ab0cc',
    redirectURL: 'https://dspdev.kingsettcapital.com',
    scopes: "api://72f4a3ee-d31a-49a9-81d7-22ceaa896746/Read",
  }
};
